import { GoatAwkward, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

type CancelOrderDrawerProps = {
	cancelOrder: () => void;
	closeModal: () => void;
	testID: string;
};

export const CancelOrderDrawer = ({ cancelOrder, closeModal, testID }: CancelOrderDrawerProps) => {
	const { $t } = useIntl();

	const cancelOrderDrawerData = {
		buttonText: $t('wallet.partnerWallet.cancelOrderDrawer.buttonText'),
		description: $t('wallet.partnerWallet.cancelOrderDrawer.description'),
		image: GoatAwkward,
		secondaryActionButtonText: $t('wallet.partnerWallet.cancelOrderDrawer.secondaryButtonText'),
		testID: testID,
		title: $t('wallet.partnerWallet.cancelOrderDrawer.title')
	};

	return (
		<GenericDrawer
			{...cancelOrderDrawerData}
			onButtonPress={() => {
				cancelOrder();
				closeModal();
			}}
			onSecondaryActionOnButtonPress={closeModal}
		/>
	);
};
